import { useEffect, useState } from 'react';
import { fetchPortalContact } from '@/portal/api/client';

export interface PortalContact {
  email: string;
  phone: string | null;
}

/**
 * Didier (CompanyTbl id=1) contact for the lookbook/PDF footer, fetched from the
 * public `/api/portal-contact` endpoint. Returns null until loaded (or on error)
 * so callers fall back to their existing CMS contact values.
 */
export function usePortalContact(): PortalContact | null {
  const [contact, setContact] = useState<PortalContact | null>(null);
  useEffect(() => {
    let alive = true;
    fetchPortalContact()
      .then((c) => {
        if (alive) setContact(c);
      })
      .catch(() => {
        /* keep null — caller uses its fallback */
      });
    return () => {
      alive = false;
    };
  }, []);
  return contact;
}
